import { OwnProps } from '~/types/ownProps';

function meetsDataDependencies(props: OwnProps) {
  const {
    application: { autoApplicants, vehicles },
  } = props;

  return autoApplicants.length > 0 && vehicles.length > 0;
}

const step = {
  route: '/homeowners-insurance/quotes/auto-discounts',
  isAccessible: ({ application }: OwnProps) => application.hasAuto,
  breadcrumbStep: 'auto',
  meetsDataDependencies,
};

export default step;
